/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HeadcountOverviewTeamMembersCountryModel } from './headcount-overview-team-members-country-model';
import { HeadcountOverviewTeamMembersRequestedTeamMemberMatchingModel } from './headcount-overview-team-members-requested-team-member-matching-model';

export interface HeadcountOverviewTeamMembersRequestedTeamMemberModel {
  state?: HeadcountOverviewTeamMembersRequestedTeamMemberModelStateEnum;
  remainingPositionsCount?: number;
  matchings?: Array<HeadcountOverviewTeamMembersRequestedTeamMemberMatchingModel> | null;
  countries?: Array<HeadcountOverviewTeamMembersCountryModel> | null;
  primaryCountry?: HeadcountOverviewTeamMembersCountryModel;
  referenceNumber?: number | null;
  title?: string | null;
  isDraft?: boolean;
  id: string;
  country?: string | null;
  countryCostType?: HeadcountOverviewTeamMembersRequestedTeamMemberModelCountryCostTypeEnum | null;
  region?: string | null;
  orgCode?: string | null;
  businessArea?: string | null;
}
export enum HeadcountOverviewTeamMembersRequestedTeamMemberModelStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
export enum HeadcountOverviewTeamMembersRequestedTeamMemberModelCountryCostTypeEnum {
  BestCost = 'BestCost',
  HighCost = 'HighCost'
}
